<template>
  <div id="remote-readiness" class="remote-readiness" style="max-width: 768px; margin: 0px auto;">
    <div class="row pt-md-4 pt-0">
      <div class="col-12">
        <h2 class="font-weight-bold remote-readiness__header">My Remote Readiness</h2>
        <!-- <div class="remote-readiness__desc d-md-block d-none">
                    {{
                        currentUser.remote_readiness_status
                            ? "Update"
                            : "Complete"
                    }}
                    your remote readiness below.
        </div>-->
        <div class="remote-readiness__desc-2">Let's see how ready your team is to work from home.</div>
      </div>
    </div>

    <div class="row py-3 about">
      <div class="col-12 d-flex justify-content-start">
        <div class="mr-2 align-self-center">
          <div class="mr-2"><user-avatar :avatarURL="currentUser.avatar_src" size="136"></user-avatar></div>
        </div>
        <div class="ml-2 align-self-center">
          <div class="name" v-text="currentUser.name"></div>
          <div class="designation" v-text="currentUser.role[0].name"></div>
          <div class="sub" v-text="currentUser.email"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        <div class="form-group">
          <label>Do you have a computer at home?</label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === data.has_computer
                            }"
            >
              <img v-if="data.has_computer" v-bind:src="'/images/icon-checked-white.svg'" alt />
              <input type="radio" :value="true" autocomplete="off" v-model="data.has_computer" />
              <span class="radio-margin">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === data.has_computer
                            }"
            >
              <img v-if="!data.has_computer" v-bind:src="'/images/icon-checked-white.svg'" alt />
              <input type="radio" :value="false" autocomplete="off" v-model="data.has_computer" />
              <span class="radio-margin">No</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="form-group">
          <label>Do you have >5mbps internet speed?</label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === data.min_internet_connection
                            }"
            >
              <img
                v-if="data.min_internet_connection"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="true"
                autocomplete="off"
                v-model="data.min_internet_connection"
              />
              <span class="ml-2">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === data.min_internet_connection
                            }"
            >
              <img
                v-if="!data.min_internet_connection"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="false"
                autocomplete="off"
                v-model="data.min_internet_connection"
              />
              <span class="radio-margin">No</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="form-group">
          <label>Can you access video conferencing on your computer?</label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === data.video_conference_access
                            }"
            >
              <img
                v-if="data.video_conference_access"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="true"
                autocomplete="off"
                v-model="data.video_conference_access"
              />
              <span class="ml-2">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === data.video_conference_access
                            }"
            >
              <img
                v-if="!data.video_conference_access"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="false"
                autocomplete="off"
                v-model="data.video_conference_access"
              />
              <span class="radio-margin">No</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="form-group">
          <label>Can you focus on work at home?</label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 1 === data.focus_work_at_home
                            }"
            >
              <img
                v-if="data.focus_work_at_home === 1"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="1" autocomplete="off" v-model="data.focus_work_at_home" />
              <span class="ml-2">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 2 === data.focus_work_at_home
                            }"
            >
              <img
                v-if="data.focus_work_at_home === 2"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="2" autocomplete="off" v-model="data.focus_work_at_home" />
              <span class="radio-margin">No</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 3 === data.focus_work_at_home
                            }"
            >
              <img
                v-if="data.focus_work_at_home === 3"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="3" autocomplete="off" v-model="data.focus_work_at_home" />
              <span class="ml-2">Sometimes</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="form-group">
          <label>Do you have a comfortable chair and desk to work on?</label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: true === data.comfortable_chair_table
                            }"
            >
              <img
                v-if="data.comfortable_chair_table"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="true"
                autocomplete="off"
                v-model="data.comfortable_chair_table"
              />
              <span class="ml-2">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: false === data.comfortable_chair_table
                            }"
            >
              <img
                v-if="!data.comfortable_chair_table"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input
                type="radio"
                :value="false"
                autocomplete="off"
                v-model="data.comfortable_chair_table"
              />
              <span class="radio-margin">No</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="form-group">
          <label>
            Do you have have a quiet work area space at
            home?
          </label>
          <br />
          <div class="btn-group btn-group-toggle">
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 1 === data.quiet_work_space
                            }"
            >
              <img
                v-if="data.quiet_work_space === 1"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="1" autocomplete="off" v-model="data.quiet_work_space" />
              <span class="ml-2">Yes</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 2 === data.quiet_work_space
                            }"
            >
              <img
                v-if="data.quiet_work_space === 2"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="2" autocomplete="off" v-model="data.quiet_work_space" />
              <span class="radio-margin">No</span>
            </label>
            <label
              class="btn radio-btn"
              v-bind:class="{
                                active: 3 === data.quiet_work_space
                            }"
            >
              <img
                v-if="data.quiet_work_space === 3"
                v-bind:src="'/images/icon-checked-white.svg'"
                alt
              />
              <input type="radio" :value="3" autocomplete="off" v-model="data.quiet_work_space" />
              <span class="ml-2">Sometimes</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 text-center col-md-6 mx-auto">
        <div class="form-group">
          <button
            class="btn btn-save"
            @click="saveChanges()"
            :disabled="(currentUser.remote_readiness_status &&!dataChanged) ||loading"
          >
            <span class="spinner-border" role="status" v-show="loading">
              <span class="sr-only">Loading...</span>
            </span>
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentUser: {
        avatar: "",
        name: "",
        email: "",
        designation: "",
        remote_readiness_status: true,
        role: ""
      },
      originalData: {
        has_computer: true,
        min_internet_connection: true,
        video_conference_access: true,
        focus_work_at_home: 1,
        comfortable_chair_table: true,
        quiet_work_space: 1
      },
      data: {
        has_computer: true,
        min_internet_connection: true,
        video_conference_access: true,
        focus_work_at_home: 1,
        comfortable_chair_table: true,
        quiet_work_space: 1
      },
      loading: false
    };
  },

  computed: {
    dataChanged() {
      const originalData = Object.values(this.originalData);
      const newData = Object.values(this.data);

      for (let i = 0; i < originalData.length; i++) {
        if (originalData[i] !== newData[i]) {
          return true;
        }
      }

      return false;
    }
  },

  methods: {
    async getCurrentUser() {
      const url = "/me";
      const data = await axios.get(url);
      const readiness = data.data.data.remote_readiness;

      this.currentUser = data.data.data;
      this.originalData = readiness;
      this.data = Object.assign({}, readiness);
    },

    async saveChanges() {
      try {
        await axios.post("/user-remote-readiness", this.data);

        location.href = this.currentUser.remote_readiness_status
            ? "#remote-readiness"
            : "/dashboard";
        window.scrollTo(0, 0);
      } catch (e) {
        this.loading = false;
      }
    }
  },

  mounted() {
    this.getCurrentUser();
  }
};
</script>

<style scoped lang="scss">
.remote-readiness {
  &__header {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 53.2px;
    text-align: center;
    @media (max-width: 768px) {
      text-align: left;
      font-size: 24px;
      margin-bottom: 0;
    }
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;

    @media (max-width: 768px) {
      text-align: left;
      font-size: 14px;
    }

    &-2 {
      color: #606064;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 20px;
      text-align: center;
      margin-bottom: 42px;

      @media (max-width: 768px) {
        text-align: left;
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }

  label {
    color: #808fa4;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 22px;
  }

  .radio-btn {
    min-width: 108px;
    justify-content: space-evenly;
    border-radius: 3px !important;
    background-color: #f2f2f2;
    height: 50px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    color: #98a6ba;
    font-family: Montserrat;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    font-weight: 100;

    input {
      color: white;
    }

    span {
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
      text-align: center;
    }
  }

  .radio-btn.active {
    border-radius: 4px;
    background-color: #3592ff;
    color: white;
    @media (max-width: 768px) {
      .radio-margin {
        margin-left: 1rem;
      }
    }
  }

  .radio-btn:last-child {
    margin-right: 0;
  }

  button {
    padding: 10px 18px;
    border-radius: 6px;
    background-color: #000000;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    color: #fff;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    height: 56px;
    margin-top: 48px;
  }

  :root {
    --avatar-size: 40px;
  }

  .about {
    margin-bottom: 39px;
  }

  .name {
    color: #333333;
    font-family: "Open Sans", sans-serif;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 43px;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 14px;
      margin-bottom: -10px;
    }
  }

  .designation {
    color: #8392a6;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    text-align: left;
    margin-bottom: 8px;

    @media (max-width: 768px) {
      font-size: 12px;
      margin-bottom: -10px;
    }
  }

  .sub {
    color: #808fa4;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 10px;
    }
  }

  @media (max-width: 768px) {
    .radio-btn {
      min-width: auto;
      justify-content: center !important;
      .radio-margin {
        /* margin-left: 0; */
      }
    }
    .btn-group {
      width: 100%;
    }
  }

  .btn-save {
    height: 56px;
    width: 320px;
    color: #ffffff;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    background: #000000;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
